export const updateMessage = 'updateMessage';
export const updateVisibility = 'updateVisibility';
export const showSnackbarWithMessage = 'showSnackbarWithMessage';
